export default __webpack_public_path__ + "static/media/m.package.00ae3f11.png";